import React from 'react';
import { useLoggedInUser } from '../../../../../context';
import type { PatientTO } from '../../../../../lib';
import { type ClinicianOption } from '../../../Table/components/AssignToSomeoneElse/AssignToSomeoneElse';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import AssignedToField from './AssignToField';

interface PatientProfileHeaderAssignedToProps {
  patient: PatientTO;
  favouritedClinicians: any[];
}
const PatientProfileHeaderAssignedTo = ({
  patient,
  favouritedClinicians,
}: PatientProfileHeaderAssignedToProps) => {
  const { loggedInUser } = useLoggedInUser();

  const { clinics } = useSelector((state: RootState) => state.clinicianProfile);

  const clinicianOptions: ClinicianOption[] = React.useMemo(() => {
    if (!clinics) {
      return [];
    }
    const hospitals = clinics.filter(
      (clinic) => clinic.organisation_unit === 'hospital',
    );
    const patientBelongsTo = patient.clinicIds;
    if (hospitals.length === 0 || patientBelongsTo.length === 0) {
      return [];
    }

    return patient.clinicIds.flatMap((clinicId: number) => {
      const availableClinics = hospitals.find(
        (hospital) => hospital.clinic_id === clinicId,
      );

      // Skip if no matching clinic or clinicians
      const clinicians = availableClinics?.caremapprClinicians ?? [];

      return clinicians
        .map((clinician) => ({
          label: `${clinician.first_name} ${clinician.last_name}`,
          value: clinician.user_id,
        }))
        .filter((clinician) => clinician.value !== loggedInUser?.userId);
    });
  }, [clinics]);

  return (
    <AssignedToField
      assignedTo={favouritedClinicians}
      patient={patient}
      clinicianOptions={clinicianOptions}
    />
  );
};

export default PatientProfileHeaderAssignedTo;
